import React from 'react'

export const Missing = () => {
  return (
    <main className='Missing'>
      <h2>Page Not Found</h2>
      <p>Well, that's disappointing.</p>
      <p>
        Visit our Homepage
      </p>
    </main>
  )
}

